(($, Drupal, drupalSettings) => {
  Drupal.behaviors.userautocomplete = {
    attach: (context, settings) => {
      // $(context.querySelectorAll('.user-filters')).once('userSelector').each( (i, item) => {
      $(once('userSelector', '.user-filters' )).each( (i, item) => {
        new SelectionHandler(item);
      });
    },
    updateResultSummary: () => {
      const $summaryWrapper = $('#block-ingressregionforuserslistings .result-summary-wrapper').text('');
      $('.view-id-professionals .view-header .result-summary').appendTo($summaryWrapper).show();
    }
  }

  var SelectionHandler = function(group) {
    this.el = group;
    this.init();
  }

  SelectionHandler.prototype = {
    sel: [
      'region',
      'professional',
      'speciality',
      'language',
    ],
    init: function(){
      Drupal.behaviors.userautocomplete.updateResultSummary();

      const _updateView = () => {
        const _clean = prefix => {
          return ( this[prefix].value !== 'all' ? prefix + '=' + this[prefix].value : '');
        }

        const _createUrl = () => {
          return '?' + this.sel.map( i => _clean(i)).filter( el => el != '').join('&');
        }

        var search = _createUrl();
        var langCode = '/'+drupalSettings.path.currentLanguage;
        langCode = (langCode == '/fi') ? '' : langCode;

        Drupal.ajax({
          url: langCode+'/list-users/ajax' + search + '&path=' + drupalSettings.path.currentPath,
        }).execute().done(function(response) {
          Drupal.behaviors.userautocomplete.updateResultSummary();
        });

        if (history.pushState) {
          window.history.pushState({path:search},'',search);
        }

      }

      const selectAndBind = sel => {
        var el = this.el.querySelector('.' + this.sel[sel] + '-select');
        if(el) {
          el.addEventListener('change', _updateView.bind(this) );
          return el;
        }
        else {
          delete this.sel[sel];
        }
      }

      this.sel.forEach( (index, i) => this[index] = selectAndBind(i));

    }
  }

})(jQuery, Drupal, drupalSettings);
